export default [
  {
    path: '/digital-replies',
    name: 'digital-replies',
    component: () => import('@/views/digitalReplies/DigitalRepliesSearch.vue'),
    meta: {
      clinicianBlocked: true,
      printQueueUserBlocked: true,
      protected: true,
      pageTitle: 'Digital Reply Search',
      breadcrumb: [
        {
          text: 'Digital Reply Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/digital-replies/reply/:id',
    name: 'digital-reply-view',
    props: true,
    component: () => import('@/views/digitalReplies/digitalReplyView/DigitalReplyView.vue'),
    meta: {
      protected: true,
      pageTitle: 'View Digital Reply',
      breadcrumb: [
        {
          text: 'View Digital Reply',
          active: true,
        },
      ],
    },
  },
];
